import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import * as Types from "./types";

export const pitRateListService = (params: Types.PITRateListRequest) =>
  RestAPIClient.call<Types.PITRateListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.List,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const pitRateCreateService = (params: Types.PITRateCreateRequest) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.POST,
    url: Paths.Create,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const pitRateUpdateService = (params: Types.PITRateUpdateRequest) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.PUT,
    url: `${Paths.Update}/${params.id}`,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const pitRateDetailService = (id: string) =>
  RestAPIClient.call<Types.PITRate>({
    method: HTTPRequestMethods.GET,
    url: `${Paths.Update}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });
